import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Trans, useTranslation } from 'react-i18next';
export const isCirclekDomain = (hostname = window.location.hostname) => hostname.split('.')[0] === 'circlek';
const IFINANCE_HOME_URL = 'https://ifinancecanada.com/';
const pageStyle = {
    flex: '1 1 auto',
    background: 'var(--white)',
    padding: '10rem 2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
};
const contentStyle = {
    width: '100%',
    maxWidth: '96rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};
const titleStyle = {
    fontSize: 'clamp(3rem, 4vw, 4rem)',
    fontWeight: 700,
    color: 'var(--dark-blue)',
    lineHeight: 1.2,
    marginBottom: '4rem',
};
const subtitleStyle = {
    fontSize: '1.7rem',
    fontWeight: 400,
    color: 'var(--dark-blue)',
    lineHeight: 1.75,
    marginBottom: '6rem',
    opacity: 0.9,
    maxWidth: '56rem',
};
const buttonStyle = {
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: '1.8rem',
    fontWeight: 600,
    padding: '2rem 3.6rem',
    gap: '1rem',
};
const footnoteStyle = {
    fontSize: '1.3rem',
    color: 'var(--text-secondary)',
    lineHeight: 1.75,
    marginTop: '4.4rem',
    maxWidth: '44rem',
};
const accentSpanStyle = {
    color: 'var(--accent-blue)',
    fontWeight: 600,
};
export const CirclekDiscontinuationPage = () => {
    const { t } = useTranslation('shared');
    return (_jsxs("main", { id: "circlek-discontinuation", style: pageStyle, children: [_jsx("style", { children: `
        @media (min-width: 1024px) {
          #circlek-discontinuation h1 {
            white-space: nowrap;
          }
        }
      ` }), _jsxs("div", { style: contentStyle, children: [_jsx("h4", { className: "subtitle", children: t('circlekDiscontinuation.eyebrow') }), _jsx("h1", { style: titleStyle, children: t('circlekDiscontinuation.title') }), _jsx("p", { style: subtitleStyle, children: t('circlekDiscontinuation.subtitle') }), _jsxs("a", { className: "btn btn-blue", href: IFINANCE_HOME_URL, style: buttonStyle, children: [t('circlekDiscontinuation.linkText'), _jsx("span", { "aria-hidden": "true", children: "\u2192" })] }), _jsx("p", { style: footnoteStyle, children: _jsx(Trans, { i18nKey: "circlekDiscontinuation.footnote", ns: "shared", components: { accent: _jsx("span", { style: accentSpanStyle }) } }) })] })] }));
};
